import React, {CSSProperties} from "react";

type DropdownProps = {
    name: string;
    value?: any;
    data: Array<any>;
    label?: string;
    defaultItem?: { id?: any; name: string };
    icon?: React.ElementRef<any>;
    onChange?: (value: any) => void;
    disabled?: boolean;
    displayMember?: string;
    valueMember?: string;
    valueFormatter?: (value: any) => string;
    labelStyles?: CSSProperties;
}

const Dropdown: React.FC<DropdownProps> =
    ({
         value,
         name,
         data,
         displayMember,
         valueMember,
         label,
         onChange,
         icon,
         disabled,
         defaultItem,
         valueFormatter,
         labelStyles
     }) => {

        const isPrimitive = !(data[0] instanceof Object);
        const defaultValueMember = data[0] && data[0].hasOwnProperty("slug") ? "slug" : "id";
        const defaultDisplayMember = "name";

        let defaultItemOption = null;

        if (defaultItem) {
            defaultItemOption = (
                <option value={defaultItem.id ?? ""} selected={true}>
                    {defaultItem.name}
                </option>
            )
        }

        return <>
            {label && <div className="form-label">
                <label htmlFor={name} style={{...labelStyles}}>{label}: </label>
            </div>}
            <div className={["form-control", disabled ? "disabled" : ""].join(" ")}>
                {icon}
                <select
                    name={name}
                    id={name}
                    value={value}
                    required
                    onChange={(e) => {
                        onChange && onChange(e.target.value);
                    }}>
                    {defaultItemOption}

                    {data.map((item) => {
                        if (isPrimitive) {
                            const formattedValue = valueFormatter ? valueFormatter(item) : item;
                            return (
                                <option value={item}>
                                    {formattedValue}
                                </option>)
                        }

                        const val = item[valueMember ?? defaultValueMember];
                        const text = item[displayMember ?? defaultDisplayMember];
                        return (
                            <option
                                value={val}
                                selected={val === value}>
                                {valueFormatter ? valueFormatter(text) : text}
                            </option>
                        )
                    })}
                </select>
            </div>
        </>
    }

export default Dropdown;